import { FC } from 'react'
import cx from 'classnames'
import { Link } from 'react-router-dom'

import Styles from './ArticleCard.module.scss'
import { getInitials, pluralize } from 'utils'
import Avatar from 'common/Avatar/Avatar'

interface Article {
  copies_count: number
  cover_image_url: string | null
  creator_name?: string | null
  creator_url: string
  creator_image_url: string | null
  creator_company: string | null
  creator_role: string | null
  id: string
  likes_count: number
  title: string
  url: string
}

export interface Props {
  article: Article
  className?: string
  showStats?: boolean
}

export const ArticleCard: FC<React.PropsWithChildren<Props>> = ({ article, className, showStats = true }: Props) => {
  return (
    <div className={cx(Styles.card, className)}>
      <Link
        to={article.url}
        className={Styles.image}
        style={{ backgroundImage: `url(${article.cover_image_url})` }}
      ></Link>
      <div className={Styles.content}>
        <div className={cx(Styles.header, { [Styles.withStats]: showStats })}>
          <div>
            <h3 className={Styles.title}>
              <Link to={article.url}>{article.title}</Link>
            </h3>
            <Link to={article.creator_url} className={Styles.subTitle}>
              <div className={Styles.creator}>
                <div className={Styles.avatarContainer}>
                  <Avatar label={getInitials(article.creator_name)} url={article.creator_image_url} size={40} />
                </div>
                <div className={Styles.info}>
                  <div className={Styles.name}>{article.creator_name}</div>
                  {(!!article.creator_role || !!article.creator_company) && (
                    <div className={Styles.details}>
                      {article.creator_role}
                      {article.creator_role && article.creator_company && ' at '}
                      {article.creator_company}
                    </div>
                  )}
                </div>
              </div>
            </Link>
          </div>
        </div>
        {showStats && (
          <div>
            <span className={Styles.stat}>
              <strong>{article.copies_count}</strong>
              {pluralize('copy', article.copies_count)}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
